"use strict";

const { select, subscribe } = wp.data;

/**
 * Implements the page menu.
 */
class PageMenu {
	constructor( menu ) {
		var self = this;
		this.menu = menu;
		this.addControls();
		this.selectedUseCase = select( 'iportal-core' ).getSelectedUseCase();
		this.filterUseCase();
		subscribe( () => {
			const useCase = select( 'iportal-core' ).getSelectedUseCase();
			if ( useCase !== this.selectedUseCase ) {
				this.selectedUseCase = useCase;
				this.filterUseCase();
			}
		} );
	};

	// Add hide/unhide controls
	addControls() {
		var $menu = jQuery( this.menu );
		$menu.find( '.page-menu__sub-menu' ).siblings( 'a' ).each( function() {
			var direction = 'right';
			if( jQuery( this ).parent().hasClass( 'current_page_ancestor' )
				|| jQuery( this ).parent().hasClass( 'current_page_item' ) ) {
				direction = 'down';
			}
			var control = jQuery( '<a class="page-menu__sub-menu-control"><i class="fa fa-chevron-' + direction + '"></i></a>' );
			jQuery( this ).prepend( control );
			control.on( 'click', function( event ) {
				event.preventDefault();
				jQuery( this ).find( '.fa' )
					.toggleClass( 'fa-chevron-down' )
					.toggleClass( 'fa-chevron-right' );
				jQuery( this ).parent().siblings( 'ul' ).slideToggle();
			} );
		} );
	};

	// Filter page menu by selected use case.
	filterUseCase() {
		for ( const item of this.menu.querySelectorAll( '.page-menu__sub-menu-control' ) ) {
			item.style.display = '';
		}
		for ( const item of this.menu.querySelectorAll( '.page_item' ) ) {
			item.style.display = 'block';
		}
		for ( const item of this.menu.querySelectorAll( '.page_item' ) ) {
			var useCases = item.dataset.useCases;
			if (
				this.selectedUseCase !== ''
					&& ( useCases === undefined
							 || ! useCases.split( ' ' ).includes( this.selectedUseCase ) ) ) {
				item.style.display = '';
				var anySiblingVisible = false;
				for ( const sibling of item.parentNode.childNodes ) {
					if ( sibling.style.display === 'block' ) {
						anySiblingVisible = true;
						break;
					}
				}
				if ( ! anySiblingVisible && item.parentNode.previousSibling ) {
					item.parentNode.previousSibling.firstChild.style.display = 'none';
				}
			}
		}
	}
};

export default PageMenu;
